<template>
  <v-row class="no-jobs-banner mb-2 py-4 px-2">
    <v-col cols="12" sm="1" class="text-center py-0" align-self="center">
      <v-img
        :src="require(`@/assets/img/banners/briefcase.png`)"
        class="m-auto"
        :width="$vuetify.breakpoint.smAndDown ? '35px' : '55px'"
      />
      <!-- <v-icon color="#A7ACB1" x-large left>mdi-briefcase-remove-outline</v-icon> -->
    </v-col>
    <v-col
      cols="12"
      sm="8"
      align-self="center"
      class="py-0 px-4 my-2"
      :class="$vuetify.breakpoint.smAndDown ? 'text-center' : ''"
    >
      <p class="display-18 font-weight-medium tertiary--text">
        לא מצאנו משרות פעילות שעונות על החיפוש שלך:
      </p>
      <p class="display-18 tertiary--text">
        {{ WhatFieldText }}
        <span v-if="WhereFieldText">
          <span class="d-inline-block px-2">|</span>
          {{ WhereFieldText }} ({{ Range }})
        </span>
      </p>
    </v-col>
    <v-col
      cols="12"
      sm="3"
      align-self="center"
      class="text-center py-0"
      :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
    >
      <v-btn
        rounded
        color="primary"
        outlined
        class="px-2"
        width="150px"
        @click="newSearch()"
      >
        חיפוש חדש
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    WhatFieldText: {
      type: String,
      required: false,
      default: '',
    },
    WhereFieldText: {
      type: String,
      required: false,
      default: '',
    },
    Range: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    newSearch() {
      try {
        document
          .querySelector('#search-input-wrpper input[data-cy=what-input]')
          .focus();
        window.scrollTo(0, 0);
      } catch (error) {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>


<style lang="sass" scoped>
.no-jobs-banner
  border: 1px solid #E3E3E4
  max-width: 934px
  margin: auto
</style>